









import Vue from "vue";
import MainColumns from "@/components/templates/MainColumns.vue";
import AdminUsersList from "@/components/organisms/AdminUsersList.vue";
import Notifications from "@/components/organisms/Notifications.vue";

export default Vue.extend({
  name: "UsersAdmin",
  components: {
    MainColumns,
    Notifications,
    AdminUsersList,
  },
});
